import Icon from '../components/Icon.vue'

Icon.register({
  microphone: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M176 352c-53 0-96-43-96-96v-160c0-53 43-96 96-96s96 43 96 96v160c0 53-43 96-96 96zM336 192c8.8 0 16 7.2 16 16v48c0 88.9-66.3 162.5-152 174.2v33.8h56c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h56v-34.2c-88-12.1-152-92-152-181.7v-40.2c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v42.3c0 66.8 48.7 126.6 115.2 133.1 76.3 7.4 140.8-52.6 140.8-127.4v-48c0-8.8 7.2-16 16-16h16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microphone.js
// module id = 1567
// module chunks = 0